export const DEFAULT_API_TIMEOUT_MS = 120_000 // 2 minutes
export const BATCH_API_TIMEOUT_MS = 180_000 // 3 minutes
/** Inscription préinscription (conditionnel = 2× Django + report notes) / lot massif. */
export const PREINSCRIPTION_INSCRIRE_TIMEOUT_MS = 300_000 // 5 minutes
export const PREINSCRIPTION_INSCRIRE_LOT_TIMEOUT_MS = 600_000 // 10 minutes

/** Timeout adapté selon l'endpoint (proxy Nuxt + client $fetch). */
export function getApiRequestTimeoutMs(path: string, method = 'GET'): number {
    const normalized = path.toLowerCase()
    if (normalized.includes('preinscriptions/inscrire-lot') || normalized.includes('crm-nouveaux/inscrire')) {
        return PREINSCRIPTION_INSCRIRE_LOT_TIMEOUT_MS
    }
    if (normalized.includes('preinscriptions/') && normalized.includes('/inscrire')) {
        return PREINSCRIPTION_INSCRIRE_TIMEOUT_MS
    }
    if (normalized.includes('batch-complete') || normalized.includes('batch') || normalized.includes('notes/bulk')) {
        return BATCH_API_TIMEOUT_MS
    }
    if (normalized.includes('/complete')) {
        return BATCH_API_TIMEOUT_MS
    }
    if (method === 'GET' && (normalized.includes('per_page=all') || normalized.includes('per_page=-1'))) {
        if (normalized.includes('classes') || normalized.includes('sessions') || normalized.includes('maquettes') || normalized.includes('plannings')) {
            return BATCH_API_TIMEOUT_MS
        }
        return DEFAULT_API_TIMEOUT_MS
    }
    return DEFAULT_API_TIMEOUT_MS
}
